
import { PortalBaseUrl } from '../js/portalBaseUrl.js'
import Metrics from '../js/Metrics'

const httpContentType = 'application/json; charset=utf-8';

const makeAbsolute = path => path.includes('://') ? path : PortalBaseUrl.get() + path;

const SLOW_REQUESTS_TIME = 5000;

export const handleResponse = (res, startTime=Number.Max_VALUE) => {
    if (res?.redirected) {
        return { redirected: true };
    } else if (res.ok) {
        const reqTime = $date.now() - startTime;
        if (reqTime > SLOW_REQUESTS_TIME) {
            Metrics.instance().register({
                source: 'REST',
                type: 'slow-req',
                'value-int': reqTime,
                u: getRelativeUrl(res.url)
            });
        }

        return res.text()
            .then(body => {
                let data;
                try {
                    data = JSON.parse(body);
                } catch (err) {
                    data = body;
                }
                return data;
            });
    } else {
        const status = res.status;
        const statusText = res.statusText;

        res.clone().text().then(txt => {
            let error;
            try {
                const obj =  JSON.parse(txt);
                error = buildErrorString(obj)
            } catch (err) {
                error = txt;
            }
            Metrics.instance().register({
                source: 'REST',
                type: 'failed-req',
                u: getRelativeUrl(res.url),
                'value-int': status,
                t: error
            });
        });

        return res.text()
            .then(body => {
                let data;
                try {
                    data = JSON.parse(body);
                } catch (err) {
                    data = body;
                }
                throw {
                    response: {
                        data,
                        status,
                        statusText
                    }
                };
            });
    }
};

export const apiGet = path => {
    const startTime = $date.now();
    return fetch(makeAbsolute(path), {
        credentials: 'include'
    })
    .then(res => handleResponse(res, startTime));
}

export const apiGetAll = paths => {
    const startTime = $date.now();
    return Promise.all(paths.map(path => fetch(makeAbsolute(path), {
        credentials: 'include'
    })
    .then(res => handleResponse(res, startTime))));
}

export const apiPost = (path,body) => {
    const startTime = $date.now();
    return fetch(makeAbsolute(path), {
        method: 'post',
        body: body instanceof FormData ? body : JSON.stringify(body),
        credentials: 'include',
        headers: body instanceof FormData ? {} : {
            'Content-Type': httpContentType
        }
    })
    .then(res => handleResponse(res, startTime));
}

export const apiDelete = path => {
    const startTime = $date.now();
    return fetch(makeAbsolute(path), {
        method: 'delete',
        credentials: 'include'
    })
    .then(res => handleResponse(res, startTime));
}

export const apiPut = (path,body) => {
    const startTime = $date.now();
    return fetch(makeAbsolute(path), {
        method: 'put',
        body: body instanceof FormData ? body : JSON.stringify(body),
        credentials: 'include',
        headers: body instanceof FormData ? {} : {
            'Content-Type': httpContentType
        }
    })
    .then(res => handleResponse(res, startTime));
}

/**
 * Utility method to get relative url from absolute url
 */
const getRelativeUrl= url => {
    const anchor = document.createElement('a');
    anchor.href = url;
    return anchor.pathname;
}

const buildErrorString = obj => {
    let res = '';
    for (let [ key, value ] of Object.entries(obj)) {
        res += `${key}: ${value}, `;
    }
    return res;
}